"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

exports.default = webpackContext;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contextTypes = ["-activity", "-auth-strategy", "-shell", "-entity"];

// this is annoying, but webpack doesnt allow new RegExp(" ... "), must be in slashes...
var moduleContexts = {
  appModules: require.context("~/app_modules", true, /^\.\/[a-zA-Z0-9_\-]*(-activity|-auth-strategy|-shell|-entity)\/(?!.*(dist|node_modules|tests)).*\.(js|jsx|css|json)$/),
  entityModules: require.context("core/entity_modules", true, /^\.\/[a-zA-Z0-9\-]*(-activity|-auth-strategy|-shell|-entity)\/(?!.*(dist|node_modules|tests)).*\.(js|jsx|css|json)$/),
  coreModules: require.context("core/core_modules", true, /^\.\/[a-zA-Z0-9\-]*(-activity|-auth-strategy|-shell|-entity)\/(?!.*(dist|node_modules|tests)).*\.(js|jsx|css|json)$/),
  nodeModules: require.context("~/node_modules", true, /^\.\/[a-zA-Z0-9\-]*(-activity|-auth-strategy|-shell|-entity)\/(?!.*(src|node_modules|tests)).*\.(js|jsx|css|json)$/)
};

function webpackContext(module) {
  var loadMain = module.indexOf("/") === -1;
  var path = "./" + module;
  if (loadMain) path += "/";
  var result = void 0;
  var lastError = void 0;
  var success = (0, _keys2.default)(moduleContexts).some(function (k) {
    var context = moduleContexts[k];
    try {
      if (loadMain) {
        var packageJson = void 0;
        try {
          packageJson = context(path + "package.json");
        } catch (e) {}
        return k === "nodeModules" ? !!(result = context(path + (packageJson ? packageJson.main : "index.js"))) : !!(result = context(path + (packageJson ? packageJson.module || packageJson.main : "index.js")));
      } else {
        return !!(result = context(path));
      }
    } catch (e) {
      if (e.message.toLowerCase().indexOf("cannot find module") === -1) lastError = e;
    }
  });

  if (!success && lastError) throw lastError;

  return result;
}

// memo-ize this
webpackContext._keys = [];

webpackContext.keys = function () {
  var contextType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  if (contextType && contextType.charAt(0) !== "-") contextType = "-" + contextType;
  if (contextType && contextTypes.indexOf(contextType) === -1) throw new Error("incorrect context type:" + contextType);

  if (!webpackContext._keys.length) {
    (0, _keys2.default)(moduleContexts).forEach(function (k) {
      moduleContexts[k].keys().forEach(function (path) {
        var sanitizedPath = path.replace(/\.\/|\/.*$/g, "");
        if (webpackContext._keys.indexOf(sanitizedPath) === -1) webpackContext._keys.push(sanitizedPath);
      });
    });
  }

  return contextType ? webpackContext._keys.filter(function (k) {
    return k.endsWith(contextType);
  }) : webpackContext._keys;
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(contextTypes, "contextTypes", "src/core_modules/authoring-modules-webpack-context/index.js");

  __REACT_HOT_LOADER__.register(moduleContexts, "moduleContexts", "src/core_modules/authoring-modules-webpack-context/index.js");

  __REACT_HOT_LOADER__.register(webpackContext, "webpackContext", "src/core_modules/authoring-modules-webpack-context/index.js");
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/authoring-modules-webpack-context/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/authoring-modules-webpack-context/index.js
// module chunks = 0